import axios from 'axios'
import * as translationUtils from '../common-utils/translation_utils'

/**
 * Get Order Result Service
 * @param {MainWrapper} callingClass 
 * @param {string} apiUrl 
 * @param {string} authToken 
 */


 
export default function getOrderResult(callingClass, apiUrl, authToken){
  //callingClass.setAuthToken('Bearer ', true);
  window.sessionStorage.setItem('apiUrl', apiUrl);
  axios(apiUrl,{
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization' : authToken
      }
    }).then(
        (result)=>{
          let response = result.data.message;
          callingClass.setResultdata(response.OrderList.Order, false, response.moreResults, response.TotalLineList);
        }).catch(
          (error)=>{
            console.log(error);
            if(error.response!==undefined && error.response.status===403){
              window.sessionStorage.removeItem('token');
              error.message = "Auth Token Expired, Wait Till Reload";
              callingClass.setResultdata([],true);
            }else{
                callingClass.setResultdata(translationUtils.getTranslation(1478, 'No Result Found'),false);
            }
          }
        );}